import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { RouterModule } from '@angular/router';
import { CommonComponentsModule } from '@suvo-bi-core';
import { AngularMaterialModule, LogoComponent, SuvoBiClientLibModule } from '@suvo-bi-lib';

/** @deprecated */
@NgModule({
  declarations: [LogoComponent],
  exports: [
    AngularMaterialModule,
    RouterModule,
    FormsModule,
    CommonComponentsModule,
    LogoComponent,
    ReactiveFormsModule,
    GoogleMapsModule,
  ],
  imports: [
    AngularMaterialModule,
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    SuvoBiClientLibModule,
    CommonComponentsModule,
    GoogleMapsModule,
  ],
})
export class SharedModule {}
